import { render, staticRenderFns } from "./SyncObtain.vue?vue&type=template&id=3d57383a&scoped=true&"
import script from "./SyncObtain.vue?vue&type=script&lang=js&"
export * from "./SyncObtain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57383a",
  null
  
)

component.options.__file = "SyncObtain.vue"
export default component.exports